module.exports = __webpack_public_path__ + "static/media/Dia das crianças.43ecdeb0.jpg";